export enum IntegrationLogoType {
  Github = "Github",
  Jira = "Jira",
  Salesforce = "Salesforce",
  Clickup = "Clickup",
  Hubspot = "Hubspot",
  Linear = "Linear",
  YouTrack = "YouTrack",
  Topicflow = "Topicflow",
}

export const getIntegrationLogoType = (node: { __typename: string }) => {
  if (node.__typename === "GithubIssueNode") {
    return IntegrationLogoType.Github;
  } else if (node.__typename === "JiraIssueNode") {
    return IntegrationLogoType.Jira;
  } else if (node.__typename === "SalesforceOpportunityNode") {
    return IntegrationLogoType.Salesforce;
  } else if (node.__typename === "ClickupTaskNode") {
    return IntegrationLogoType.Clickup;
  } else if (node.__typename === "HubspotDealNode") {
    return IntegrationLogoType.Hubspot;
  } else if (
    node.__typename === "LinearIssueNode" ||
    node.__typename === "LinearProjectNode"
  ) {
    return IntegrationLogoType.Linear;
  } else if (
    node.__typename === "YoutrackIssueNode" ||
    node.__typename === "YouTrackIssueNode" ||
    node.__typename === "YouTrackProjectNode"
  ) {
    return IntegrationLogoType.YouTrack;
  } else if (node.__typename === "TopicflowArtifactNode") {
    return IntegrationLogoType.Topicflow;
  }
  return undefined;
};
